import { Box2, BufferAttribute, BufferGeometry, Line, Mesh, Vector3 } from '@seddi/three';
import Materials from '../materials';

class ThreeBox extends Mesh {
  readonly bounds: Box2;

  private readonly auxVector: Vector3;
  private readonly outline: Line;

  constructor() {
    const geometry = new BufferGeometry();
    geometry.setIndex(new BufferAttribute(new Uint8Array([0, 1, 2, 2, 3, 0]), 1));
    geometry.setAttribute('position', new BufferAttribute(new Float32Array(4 * 3), 3));
    super(geometry, Materials.Box);
    {
      const points = new BufferGeometry();
      points.setAttribute('position', new BufferAttribute(new Float32Array(5 * 3), 3));
      const outline = new Line(points, Materials.BoxOutline);
      this.add(outline);
      this.outline = outline;
    }
    this.auxVector = new Vector3();
    this.bounds = new Box2();
  }

  update({ camera, points }) {
    const { auxVector: vector, bounds, geometry, outline } = this;
    bounds.makeEmpty();
    points.forEach((point) => {
      bounds.expandByPoint(point);
    });
    bounds.makeEmpty();
    points.forEach((point) => {
      bounds.expandByPoint(point);
    });
    const vertices = [
      { x: bounds.min.x, y: bounds.min.y },
      { x: bounds.max.x, y: bounds.min.y },
      { x: bounds.max.x, y: bounds.max.y },
      { x: bounds.min.x, y: bounds.max.y },
    ]
      .map((point) => {
        vector.set(point.x, point.y, 0).unproject(camera);
        return { x: vector.x, y: vector.y, z: vector.z };
      })
      .reduce((vertices, point) => {
        vertices.push(point.x, point.y, point.z);
        return vertices;
      }, []);
    geometry.attributes.position.array.set(vertices);
    geometry.attributes.position.needsUpdate = true;
    geometry.computeBoundingSphere();
    outline.geometry.attributes.position.array.set([
      ...vertices,
      vertices[0],
      vertices[1],
      vertices[2],
    ]);
    outline.geometry.attributes.position.needsUpdate = true;
    outline.geometry.computeBoundingSphere();
  }
}

export { ThreeBox };
